import { API_URL } from '../theme/constans';

export const getFileURL = file => {
  return `${API_URL}/files/${file.id}`
}

export const maxSize = (file, size = 5) => {
  return file.size / 1024 / 1024 > size
}
